// extracted by mini-css-extract-plugin
module.exports = {"recommended":"ProductTileBase_recommended_19iTy"};